import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  StressCheckDetailsData,
  ActionType,
  IStressCheckDetailsResponse,
} from "models/stressCheck/stressCheckDetails";
import { httpStatus } from "configs/httpStatus";
import { getStressCheckDetails } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./stressCheckDetailsActions";

function* stressCheckDetailsSaga({
  payload,
}: {
  payload: StressCheckDetailsData;
}) {
  try {
    const response: IStressCheckDetailsResponse = yield call(
      getStressCheckDetails,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetStressCheckDetailsWatcher() {
  yield takeLatest(
    ActionType.STRESS_CHECK_DETAILS as any,
    stressCheckDetailsSaga
  );
}

export default [fork(onGetStressCheckDetailsWatcher)];
